module.exports = __webpack_public_path__ + "static/img/air.9f0d423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/air.png
// module id = xlzc
// module chunks = 53